<template>
	<div
		class="grid grid-cols-7 md:grid-cols-14 gap-y-1 gap-x-3 items-center justify-between px-3 py-3"
	>
		<div
			v-if="
				!(
					offer.user.type == 'FARMER' &&
					offer.trade == 'SELL'
				)
			"
			class="col-span-1 text-gray-900 whitespace-nowrap font-semibold"
		>
			{{ match.qty.mt }} t
		</div>
		<div
			v-if="
				!(
					offer.user.type == 'FARMER' &&
					offer.trade == 'SELL'
				)
			"
			class="col-span-2 text-gray-500 truncate text-sm xl:text-base"
		>
			<!-- {{ productString }} -->
			{{
				$cropOptions.getLocalizedLabel(
					match.product.grade,
					$cropOptions.productGradeOptions
				)
			}}
		</div>
		<div
			v-if="
				offer.user.type == 'FARMER' &&
				offer.trade == 'SELL'
			"
			class="col-span-3 text-gray-500 text-sm xl:text-base"
		>
			<!-- {{ productString }} -->
			{{
				$cropOptions.getLocalizedLabel(
					match.product.grade,
					$cropOptions.productGradeOptions
				)
			}}
			{{ __("Harvest") }} {{ match.product.harvest || __("n.a.") }}
		</div>

		<!-- location -->
		<div
			class="col-span-4 md:col-span-3 text-gray-500 text-sm xl:text-base leading-4 flex gap-x-2 flex-wrap xl:gap-x-3 items-center"
		>
			<div
				v-if="
					offer.user.type == 'FARMER' &&
					offer.trade == 'SELL' &&
					match.location.mode == 'DAP' &&
					match.location.optional_transport
				"
				class="whitespace-nowrap"
			>
				{{
					$cropOptions.getLocalizedLabel(
						"FCA",
						$cropOptions.locationModeOptions
					)
				}}
			</div>
			<div v-else class="whitespace-nowrap">
				{{
					$cropOptions.getLocalizedLabel(
						match.location.mode,
						$cropOptions.locationModeOptions
					)
				}}
			</div>

			<div class="whitespace-nowrap">
				<span
					v-if="
						(offer.user.type == 'FARMER' &&
							offer.trade == 'SELL' &&
							match.location.mode == 'DAP' &&
							match.location.optional_transport) ||
						(offer.user.type == 'FARMER' &&
							offer.trade == 'SELL' &&
							match.location.mode == 'FCA')
					"
				>
					{{ offer.location.address.city }}
				</span>
				<span v-else>
					{{ match.location.address.city }}
				</span>
				<span
					v-if="
						match.distance_km_road &&
						!(
							offer.user.type == 'FARMER' &&
							offer.trade == 'SELL' &&
							match.location.mode == 'DAP' &&
							match.location.optional_transport
						) &&
						!(
							offer.user.type == 'FARMER' &&
							offer.trade == 'SELL' &&
							match.location.mode == 'FCA'
						)
					"
				>
					({{ Number(match.distance_km_road).toFixed(0) }} km)
				</span>
			</div>
		</div>

		<div
			v-if="
				offer.user.type == 'FARMER' &&
				offer.trade == 'SELL'
			"
			class="col-span-7 md:col-span-4 text-gray-500 text-sm xl:text-base"
		>
			{{ $cropOptions.dateToString(match, this.locale) }}
		</div>

		<div
			v-if="
				!(
					offer.user.type == 'FARMER' &&
					offer.trade == 'SELL'
				)
			"
			class="hidden md:flex flex-nowrap text-gray-500"
		>
			<ui-icon name="arrow-left" stroke="2" class="w-5 h-5" />
			<ui-icon name="arrow-right" stroke="2" class="w-5 h-5" />
		</div>

		<!-- price -->
		<div :class="priceContainerCss">
			<div
				class="text-gray-900 font-semibold xl:flex xl:gap-x-3 items-center"
				v-if="match.price_estimate"
			>
				<div>
					<span
						v-if="
							!(
								offer.user.type == 'FARMER' &&
								offer.trade == 'SELL' &&
								match.location.mode == 'DAP' &&
								match.location.optional_transport
							)
						"
					>
						{{ __("approx.") }}
					</span>
					{{ $cropOptions.formatLocalizedNumber(match.price_estimate) }} €/t
				</div>

				<ui-tooltip
					v-if="
						!(
							offer.user.type == 'FARMER' &&
							offer.trade == 'SELL'
						)
					"
					class="text-sm xl:text-base font-normal"
					:text="
						__('This price is estimated based on freight cost indications')
					"
				>
					<template v-slot:label
						><span class="cursor-help text-orange-500"
							>{{ __("Freight cost") }} ca.
							{{ $cropOptions.formatLocalizedNumber(match.freight_cost_eur) }}
							€/t</span
						></template
					>
				</ui-tooltip>
			</div>

			<div
				class="text-gray-900 font-semibold flex items-center"
				v-else-if="match.price.mt"
			>
				<div class="mr-3">
					{{
						match.price.mt == null
							? ""
							: $cropOptions.formatLocalizedNumber(match.price.mt) +
							  " €/t " +
							  matchPriceWarning
					}}
				</div>

				<div
					v-if="
						!(
							offer.user.type == 'FARMER' &&
							offer.trade == 'SELL' &&
							match.location.mode == 'FCA'
						)
					"
					class="text-gray-500 font-normal text-sm xl:text-base"
				>
					{{ __("without freight charges") }}
				</div>
				<!-- __('This price is net of any freight charges')"-->
			</div>

			<div class="text-gray-500 xl:flex items-center text-sm" v-else>
				{{ __("No price provided") }} &nbsp;<br />
				<span v-if="match.freight_cost_eur">
					{{
						__("messages.freight_charges", {
							args: {
								cost: $cropOptions.formatLocalizedNumber(
									match.freight_cost_eur
								),
							},
						})
					}}
				</span>
			</div>

			<ui-button
				v-if="match.thread"
				type="primary"
				v-on:click="$inertia.visit($route('threads', { active_id: match.thread.id }))"
				class="ml-auto text-sm flex-shrink-0"
				>
				{{ __("To negotiation") }}
			</ui-button>

			<ui-button
				v-else
				type="primary"
				class="ml-auto text-sm flex-shrink-0"
				v-on:click="
					$bus.$emit(
						'toggle-iframe-modal',
						$route('bid.create', {
							targetType: match.trade,
							targetId: match.id,
							sourceId: offer.id,
						}) + '?iframe_modal=true'
					)
				"

				>
				{{
					match.trade == "BUY"
						? offer.user.type == "FARMER"
							? __("Offer Quantity")
							: __("Offer")
						: __("Bid")
				}}
			</ui-button>


		</div>
	</div>
</template>

<script>
let options = require("../cropOptions.js");

export default {
	props: {
		// ausgehendes Inserat
		offer: {
			type: Object,
			required: true,
		},
		// matchendes Inserat
		match: {
			type: Object,
			required: true,
		},
		showQuality: {
			type: Boolean,
			required: false,
			default: true,
		},
	},
	computed: {
		matchPriceWarning() {
			// todo prüfen, distance_max so nicht mehr vorhanden
			let o = this.match;
			if (o.location.distance_max > 0) {
				if (this.trade == "SELL") {
					// sell offer with radius: must be delivery, i.e. freight cost on top
					return this.__("(plus freight costs)");
				} else {
					// buy offer with radius: must be pick-up, i.e. freight cost deducted
					return this.__("(minus freight costs)");
				}
			} else {
				return "";
			}
		},
		priceContainerCss() {
			return this.offer.user.type == "FARMER" &&
				this.offer.trade == "SELL"
				? "col-span-7 md:col-span-4 flex flex-nowrap items-center justify-center leading-4"
				: "col-span-7 xl:col-span-7 flex flex-nowrap items-center justify-center leading-4";
		},
	},
	data() {
		return {
			o: options,
		};
	},
};
</script>
